<ng-container [matColumnDef]="columnKeyName">
    <mat-header-cell *matHeaderCellDef>
        <div class="full-height full-width flex-column flex-center-start">
            <p
                class="column-title unselectable"
                i18n
            >
                Company
            </p>
            @if (!entityBrowser.hideFilters) {
            <mat-form-field
                appearance="outline"
                class="full-width"
            >
                <!--suppress HtmlFormInputWithoutLabel -->
                <input
                    matInput
                    type="text"
                    i18n-placeholder
                    placeholder="All"
                    disabled
                />
            </mat-form-field>
            }
        </div>
    </mat-header-cell>

    @if (cellTemplate) {
    <div>
        <mat-cell *matCellDef="let entity">
            <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: entity }"></ng-container>
        </mat-cell>
    </div>
    } @else {
    <mat-cell *matCellDef="let entity">
        @if (!isCompanyFromTickets) {
        <p
            class="text-ellipsis"
            #tooltip="matTooltip"
            [matTooltip]="getEntityProperty(entity)"
            [matTooltipDisabled]="entityBrowser.disableTooltip"
            (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip)"
        >
            {{ getEntityProperty(entity) }}
        </p>
        } @if (isCompanyFromTickets) {
        <p
            class="text-ellipsis"
            #tooltip="matTooltip"
            [matTooltip]="getEntityPropertyForCompanyOnTickets(entity)"
            [matTooltipDisabled]="entityBrowser.disableTooltip"
            (mouseover)="entityBrowser.checkInputClientVisibility($event, tooltip)"
        >
            {{ getEntityPropertyForCompanyOnTickets(entity) }}
        </p>
        }
    </mat-cell>
    }
</ng-container>
